import { render } from "./AlertMessage.vue?vue&type=template&id=b16f71b8&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=b16f71b8&lang=scss&scoped=true"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-57de6a73e2/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16f71b8"]])

export default __exports__